import { BooleanField, OrmModel, StringField, AttrField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

export enum EmailCampaignDomainStatus {
  NotVerified = 'not_verified',
  Pending = 'pending',
  ManualReview = 'manual_review',
  Rejected = 'rejected',
  Verified = 'verified',
}

export enum EntriVerificationStatus {
  Pending = 'pending',
  Success = 'success',
  Failed = 'failed',
}

@OrmModel(modelNames.EMAIL_CAMPAIGN_DOMAIN)
export default class EmailCampaignDomain extends BaseModel {
  @StringField()
  public domain: string

  @StringField()
  public dkimPendingHost: string

  @StringField()
  public dkimPendingTextValue: string

  @BooleanField()
  public isDkimPendingHostVerified: boolean

  @StringField()
  public returnPathDomain: string

  @StringField()
  public returnPathDomainValue: string

  @BooleanField()
  public isReturnPathDomainVerified: boolean

  @StringField()
  public dmarcRecordName: string

  @StringField()
  public dmarcRecordValue: string

  @BooleanField()
  public isDmarcRecordVerified: boolean

  @StringField()
  public status: EmailCampaignDomainStatus

  @StringField(null)
  public entriVerificationStatus: EntriVerificationStatus | null

  @StringField(null)
  public dnsProvider: string | null

  @AttrField(null)
  public isAvailableForEntriVerification: boolean | null

  public get isDnsVerified(): boolean {
    return this.status !== EmailCampaignDomainStatus.NotVerified && this.status !== EmailCampaignDomainStatus.Rejected
  }
}
